import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TitleWidth } from './translationUiConst';

class SolarBasicInfo extends Component {
  render() {
    const {
      operationStartDt = "",
      diff = "",
      ownerName = "",
      t,
      i18n
    } = this.props;
    return (
      <TitleWrapper>
        <h4>{t('key184')}</h4>
        <CommonContainer>
                  <TitleWithInfoContainer titleWidth={TitleWidth(i18n).title}>
            <span className='tit'>{t('key185')}</span>
            <span>{operationStartDt}</span>
            <span className='sub'>({diff})</span>
          </TitleWithInfoContainer>
          <TitleWithInfoContainer titleWidth={TitleWidth(i18n).title}>
            <span className='tit'>{t('key186')}</span>
            <span>{ownerName}</span>
          </TitleWithInfoContainer>
        </CommonContainer>
      </TitleWrapper>
    )
  }
}


const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  & h4 {
    font-size: 18px;
    font-weight: 700;
    height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
  }
`;

const CommonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  gap: 10px;
  background-color: #F2F3F5;
  border-radius: 12px;
`;

const TitleWithInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;

  span {
    height: 28px;
    line-height: 28px;
  }
  .tit {
    ${({ titleWidth }) => titleWidth ? `width: ${titleWidth};` : 'width: 100px;'}
    font-weight: 600;
  }
  .sub {
    font-size: 13px;
    color: #797979;
  }
  .divider {
    border-left: 1px solid black;
    width: 1px;
    height: 12px;
  }
`;

export default withTranslation()(SolarBasicInfo);